import React from 'react';
import styles from './Index.module.css';

const SavingIndicator = ({ isSaving }) => {
    if (!isSaving) return null;

    return (
        <div className={styles.savingIndicator}>
            <svg className={styles.savingSpinner} viewBox="0 0 24 24">
                <circle className={styles.savingCircle} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
            </svg>
            <span>Saving draft...</span>
        </div>
    );
};

export default SavingIndicator;